import { createSelector } from '@mui/x-internals/store';
const selectorChartAnimationState = state => state.animation;
export const selectorChartSkipAnimation = createSelector(selectorChartAnimationState, state => state.skip || state.skipAnimationRequests > 0);